import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions'; 
import {API_URL} from '../../../constants';
import {updateValueInJson, validateAccesoGeneral, getRoles} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';

let itemChecked2 = [];
export default class AgregarProductoPriorizado extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            tituloLongitud:0,
            resource: {
                ppri_Detalle:"",
                sect_Id:0,
                ppri_LineaProductosId:"",
                ppri_Activo:true
            },
            Validacion: {
                ppri_Detalle: {
                    Error: false,                    
                },
                sect_Id: {
                    Error: false,                    
                },
                ppri_LineaProductosId: {
                    Error: false,                    
                }
            },
            resourceLinea:{
                filtroLineas:"",
                lineas:[],
                lineasIds:[]
            },
            itemChecked2:[],
            sectores: [],
            hasError:false,    
            hasErrorProceso:false,        
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);

      }

    onCheck = (item, id, e) => 
    {
        const target = e.target;
        itemChecked2[e.target.name] = !e.target.checked?false:true;

        let resourceLinea = this.state.resourceLinea;
        let lineaSeleccionadaObj = resourceLinea.lineasIds;
        if(target.type === 'checkbox' )
        {
            if(e.target.checked){
                let obj = {
                    id: id,
                    nombre: item
                }
                lineaSeleccionadaObj[id] = obj;
            }else{
                lineaSeleccionadaObj[id] = null;
            }
        }
        resourceLinea.lineasIds = lineaSeleccionadaObj;
        
        let validacion = this.state.Validacion;

        validacion.ppri_LineaProductosId= {
            Error: false,                    
        }
        
        setTimeout(() => {
            this.setState({itemChecked2, resourceLinea:resourceLinea, Validacion:validacion});
        },100)
    }
    
    handleClickCancel(e) {

        if(e != undefined){
            e.preventDefault();
        }

        const {history: {push}} = this.props;    
        push('/productos-priorizado');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        let lineas_id = [];

        this.state.resourceLinea.lineasIds.forEach(linea => {
            if(linea != null){
                lineas_id.push(linea.id);
            }  
        });


        if (newState.resource.ppri_Detalle == '') {              
            newState.Validacion.ppri_Detalle = {Error: true};
            newState.hasError = true;
        }
        if (lineas_id.length == 0) {  
            newState.Validacion.ppri_LineaProductosId = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.sect_Id == 0) {  
            newState.Validacion.sect_Id = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ProductoPriorizadoUX/`;
        var dataForm = this.state.resource;
        dataForm.ppri_LineaProductosId = lineas_id.join(",");
        dataForm = updateValueInJson(dataForm,'ppri_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                
                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.ppri_Detalle = '';
                stateResponse.resource.ppri_LineaProductosId = '';

                stateResponse.resourceLinea = {
                    filtroLineas:"",
                    lineas:[],
                    lineasIds:[]
                }

                itemChecked2 = [];
                stateResponse.itemChecked2 = [];

                stateResponse.resource.sect_Id = 0;
                document.getElementById("sect_Id").selectedIndex = 0;
                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        toast.error('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        if(target.name == 'filtroLineas'){
            let copyResource = this.state.resourceLinea;
            copyResource[target.name] = value;

            this.setState({
                resourceLinea: copyResource
            });

        }else{

            let copyResource = this.state.resource;
            copyResource[target.name] = value;

            let tituloLongitud = this.state.tituloLongitud;

            let validaciones = this.state.Validacion;
            validaciones[target.name] = {
                Error: false,                    
            }

            if(target.name == 'ppri_Detalle'){
                tituloLongitud = value.length;
            }
            this.setState({
                resource: copyResource,
                tituloLongitud: tituloLongitud,
                Validacion: validaciones
            });  

        }
    }
    
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.searchLineas();
        }
    }

    searchLineas = () => {

        let resourceLinea = this.state.resourceLinea;
        let textoFilter = resourceLinea.filtroLineas;

        if(textoFilter === '')
        {   
            resourceLinea.lineas = [];    
            this.setState({resourceLinea:resourceLinea});
            return;
        }

        const url = `${API_URL}GeneralUX/ObtenerLExportacionNombre/${textoFilter}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            resourceLinea.lineas = data.result;
            this.setState({resourceLinea:resourceLinea});
        })
        .catch(error => {
            console.log('Error de comunicación');   
        });
    }

    LineasSeleccionadas()
    {
        let lineasNombre = [];

        this.state.resourceLinea.lineasIds.forEach(linea => {
            if(linea != null){
                lineasNombre.push(linea.nombre);
            }  
        });

        return lineasNombre.length > 0 ? lineasNombre.join(',') : '';
    }

    componentDidMount()
    {
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/productos-priorizado";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol); 
        
        const url = `${API_URL}ProductoPriorizadoUX/Recursos`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            if(data.statusCode == 200){
                this.setState({
                    sectores: data.result.sectores
                });
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    render() {
        return (
            <div class="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Agregar Producto Priorizado</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Agregar Producto Priorizado
                </div>

                {
                    this.state.hasErrorProceso ? 
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar el registro.</div>
                        </div>
                    </div> : null
                }   

                {
                    this.state.added ? 
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se realizó el registro correctamente.</div>
                        </div>
                    </div>: null
                }             
                
                <div className="div_Modulos_Noticias">

                    <div className="selectRadio" style={{width:"100%"}}>
                        <div className="select x-1">
                            <select name='sect_Id' id='sect_Id' onChange={this.handleInputChange} className={this.state.Validacion.sect_Id.Error ? "error" : ""}>
                                <option value="0">Seleccionar Sector</option>
                                {
                                    this.state.sectores.length > 0 ?
                                    this.state.sectores.map((sector) => (
                                        <option value={sector.id}>{sector.nombre.toUpperCase()}</option>
                                    ))
                                    : null
                                }
                            </select>  
                        </div>
                    </div>

                    <div className="txtSelect-Radio">
                        <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Seleccione las líneas de Productos:</b></p>
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Buscar..." 
                            name="filtroLineas" 
                            value={this.state.resourceLinea.filtroLineas}
                            className="buscadorItemsProducto" 
                            onKeyDown={this._handleKeyDown}
                            onChange={this.handleInputChange}/>
                        </div>
                        <div style={{height: 250, overflowX: 'hidden', overflowY: 'scroll', border: '1px solid #DBDCDB', borderRadius: 4, boxShadow: 'inset 1px 1px 2px 0px rgb(228, 228, 228)', paddingLeft: 10, paddingTop: 10, paddingBottom: 10}}>
                            {
                                this.state.resourceLinea.lineas.length > 0 ?
                                this.state.resourceLinea.lineas.map((linea) => (
                                    <div className="inputRadio" style={{width: '100%', display: 'block'}}>
                                        <input type="checkbox" 
                                        style={{WebkitAppearance: 'checkbox'}} 
                                        name={"check_" + linea.id} 
                                        checked={this.state.itemChecked2["check_" + linea.id]}  
                                        onClick={(event) => this.onCheck(linea.nombre, linea.id, event)}/>
                                        <label>{linea.nombre}</label>
                                    </div> 
                                )) : null
                            }                           
                        </div>
                    </div>

                    <div className="textareaResumen x-1">
                        <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Lineas seleccionadas:</b></p>
                        <textarea placeholder="Lineas Seleccionadas" value={this.LineasSeleccionadas()} className={this.state.Validacion.ppri_LineaProductosId.Error ? "error" : ""} style={{height:"100px"}}/>
                    </div>

                    <div className="textareaResumen x-1">
                        <textarea placeholder="Escriba los productos separados por comas (,)" maxLength={2500} value={this.state.resource.ppri_Detalle} name="ppri_Detalle" className={this.state.Validacion.ppri_Detalle.Error ? "error" : ""} onChange={this.handleInputChange} style={{height:"100px"}}/>
                        <span data-length={2500}>{this.state.tituloLongitud}/2500</span>
                    </div>	

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />

            </div>
        )
    }
}